<template>
  <div class="page">
    <!-- 预约取书通知开始 -->
    <div class="notice" v-if="noticeType == HOLD_REQUEST">
      <div class="title">预约取书通知</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in bookNotice.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
          <div class="column">
            <span class="tit">取书地点：</span>
            {{ item.pickUpLocation }}
          </div>
          <div v-if="item.indexNumber" class="column">
            <span class="tit">索引号：</span>
            {{ item.indexNumber }}
          </div>
          <div class="column">
            <span class="tit">最晚取书日期：</span>
            <span class="red">{{ item.endHoldDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约取书通知结束 -->
    <!-- 图书到期提醒（5天）开始 -->
    <div class="notice" v-if="noticeType == LOAN_NOTICE5">
      <div class="title">图书即将到期提醒</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in loanNoticeFive.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
        </div>
      </div>
    </div>
    <!-- 图书到期提醒（5天）结束 -->
    <!-- 图书到期提醒（3天）开始 -->
    <div class="notice" v-if="noticeType == LOAN_NOTICE3">
      <div class="title">图书即将到期提醒</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in loanNoticeThree.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
        </div>
      </div>
    </div>
    <!-- 图书到期提醒（3天）结束 -->
    <!-- 图书逾期催还开始 -->
    <div class="notice" v-if="noticeType == OVERDUE_NOTICE">
      <div class="title">图书逾期催还通知</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in overDueNotice.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
        </div>
      </div>
    </div>
    <!-- 图书逾期催还结束 -->
    <!-- 图书预约取消开始 -->
    <div class="notice" v-if="noticeType == HOLD_DELETE">
      <div class="title">图书预约取消通知</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in holdDeleteNotice.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
        </div>
      </div>
    </div>
    <!-- 图书预约取消结束 -->
    <!-- 外借图书预约催还开始 -->
    <div class="notice" v-if="noticeType == URGE_RETURN">
      <div class="title">图书催还通知</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in urgeReturnNotice.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
          <div class="column">
            <span class="tit">催还应还日期：</span>
            <span class="red">{{ item.recallDueDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 外借图书预约催还结束 -->
    <!-- 外借图书取消催还开始 -->
    <div class="notice" v-if="noticeType == URGE_RETURN_CANCEL">
      <div class="title">图书催还取消通知</div>
      <div class="wrap-list">
        <div
          class="wrap-item"
          v-for="(item, index) in urgeReturnCancelNotice.list"
          :key="index"
        >
          <div class="column van-multi-ellipsis--l2">
            <span class="tit">书名：</span>
            {{ item.z13Title }}
          </div>
          <div class="column">
            <span class="tit">作者：</span>
            {{ item.z13Author }}
          </div>
          <div class="column">
            <span class="tit">应还日期：</span>
            <span class="red">{{ item.originalDueDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 外借图书取消催还结束 -->
  </div>
</template>
<script>
const HOLD_REQUEST = "HOLD_REQUEST"; //预约取书通知
const LOAN_NOTICE5 = "LOAN_NOTICE5"; //图书到期提醒（5天）
const LOAN_NOTICE3 = "LOAN_NOTICE3"; //图书到期提醒（3天）
const OVERDUE_NOTICE = "OVERDUE_NOTICE"; //图书逾期催还
const HOLD_DELETE = "HOLD_DELETE"; //图书预约取消
const URGE_RETURN = "URGE_RETURN"; //外借图书预约催还
const URGE_RETURN_CANCEL = "URGE_RETURN_CANCEL"; //外借图书取消催还
import {
  bookNotice,
  loanNoticeFive,
  loanNoticeThree,
  overDueNotice,
  holdDeleteNotice,
  urgeReturnNotice,
  urgeReturnCancelNotice,
} from "@/api/notice-content";
import { STATUS_CODE_OK, TOAST_STAY_TIME } from "@/config";
export default {
  name: "NoticeContent",
  data() {
    return {
      noticeType: HOLD_REQUEST,
      noticeDate: "",
      msgId: "",
      HOLD_REQUEST: HOLD_REQUEST,
      LOAN_NOTICE5: LOAN_NOTICE5,
      LOAN_NOTICE3: LOAN_NOTICE3,
      OVERDUE_NOTICE: OVERDUE_NOTICE,
      HOLD_DELETE: HOLD_DELETE,
      URGE_RETURN: URGE_RETURN,
      URGE_RETURN_CANCEL: URGE_RETURN_CANCEL,
      bookNotice: {
        list: [],
      },
      loanNoticeFive: {
        list: [],
      },
      loanNoticeThree: {
        list: [],
      },
      overDueNotice: {
        list: [],
      },
      holdDeleteNotice: {
        list: [],
      },
      urgeReturnNotice: {
        list: [],
      },
      urgeReturnCancelNotice: {
        list: [],
      },
    };
  },
  created() {
    let { noticeType, noticeDate, msgId } = this.$route.query;
    this.noticeType = noticeType;
    this.noticeDate = noticeDate;
    this.msgId = msgId;
    if (noticeType == HOLD_REQUEST) {
      this.handleGetBookNotice();
    }
    if (noticeType == LOAN_NOTICE5) {
      this.handleGetLoanNoticeFive();
    }
    if (noticeType == LOAN_NOTICE3) {
      this.handleGetLoanNoticeThree();
    }
    if (noticeType == OVERDUE_NOTICE) {
      this.handleGetOverDueNotice();
    }
    if (noticeType == HOLD_DELETE) {
      this.handleGetHoldDeleteNotice();
    }
    if (noticeType == URGE_RETURN) {
      this.handleGetUrgeReturnNotice();
    }
    if (noticeType == URGE_RETURN_CANCEL) {
      this.handleGetUrgeReturnCancelNotice();
    }
  },
  methods: {
    //   预约取书通知列表获取
    async handleGetBookNotice() {
      const that = this;
      let { data } = await bookNotice({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.bookNotice.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   图书到期提醒（5天）列表获取
    async handleGetLoanNoticeFive() {
      const that = this;
      let { data } = await loanNoticeFive({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.loanNoticeFive.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   图书到期提醒（3天）列表获取
    async handleGetLoanNoticeThree() {
      const that = this;
      let { data } = await loanNoticeThree({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.loanNoticeThree.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   图书逾期催还列表获取
    async handleGetOverDueNotice() {
      const that = this;
      let { data } = await overDueNotice({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.overDueNotice.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   图书预约取消列表获取
    async handleGetHoldDeleteNotice() {
      const that = this;
      let { data } = await holdDeleteNotice({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.holdDeleteNotice.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   外借图书预约催还列表获取
    async handleGetUrgeReturnNotice() {
      const that = this;
      let { data } = await urgeReturnNotice({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.urgeReturnNotice.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
    //   外借图书取消催还列表获取
    async handleGetUrgeReturnCancelNotice() {
      const that = this;
      let { data } = await urgeReturnCancelNotice({
        noticeDate: that.noticeDate,
        msgId: that.msgId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data) {
          that.urgeReturnCancelNotice.list = data.data;
        } else {
          that.$notify({
            type: "danger",
            message: "获取消息的用户信息不一致",
            duration: TOAST_STAY_TIME,
          });
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .notice {
    .title {
      text-align: center;
      padding: 10px;
      line-height: 30px;
      font-size: 16px;
      background: #fff;
    }
    .wrap-list {
      margin-top: 10px;
      background: #fff;
      .wrap-item {
        padding: 10px;
        border-bottom: 1px solid #eee;
        &:last-child {
          border-bottom: none;
        }
        .column {
          color: #777;
          margin-bottom: 6px;
          .tit {
            color: #000;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .red {
      color: #ee0a24;
    }
  }
}
</style>
